import React from 'react';

import { RegisterButtonStyled } from './styledComponents';

interface RegisterButtonProps {
  onClickRegister?: () => void;
  buttonText: string;
}

const RegisterButton: React.FC<RegisterButtonProps> = ({
  onClickRegister,
  buttonText = 'Register for the free webinar'
}) => {
  const handleClick = () => {
    if (onClickRegister) {
      onClickRegister();
    }
  };

  return (
    <RegisterButtonStyled
      id="register-webinar-button"
      onClick={handleClick}
      variant="Primary"
      size="Large"
      className="register-webinar-button"
    >
      {buttonText}
    </RegisterButtonStyled>
  );
};

export default RegisterButton;
